class GiftSelector extends HTMLElement {
  constructor() {
    super();
    this.checkoutBtn = document.querySelector('button[name="checkout"]');
    this.selectors = this.querySelectorAll('input[name="is-gift"]');
    this.gift_journey = this.querySelector('.gift__journey');
    this.journey_error = this.querySelector('.gift__error')
    this.inputs_qty = this.querySelectorAll('input[data-input="product__quantity"]');
    this.add_btns = this.querySelectorAll('button[data-product]');
    this.inputs_msg = this.querySelectorAll('[data-shopifyattribute]');
    this.gift_card_msg = {
      es_regalo: false,
      de: '',
      para: '',
      mensaje: ''
    }

  }

  connectedCallback() {
    this.selectors.forEach((btn) => btn.addEventListener('click', async () => await this.handleGiftSelector(this)));
    this.add_btns.forEach((btn) => btn.addEventListener('click', async () => await this.handleAddGiftOptionToCart(btn)));

    this.inputs_msg.forEach((input) => {
      const debounced = this.debounce(async (event) => {
        await this.inputChange(input);
      }, 1000);

      input.addEventListener('input', () => {
        input.classList.add('input__saving');
        debounced();
      });
    });
  }

  async handleGiftSelector(obj) {
    const value = obj.querySelector('input[name="is-gift"]:checked').value === 'true' ? true : false;
    this.gift_card_msg.es_regalo = value;
    if (value) {
      this.gift_journey.classList.remove('hidden');
      this.validateJourney();
    } else {
      this.gift_journey.classList.add('hidden');
      this.validateJourney();
    }
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          "es_regalo": value ? 'si' : 'no'
        }
      })
    });
  }

  async handleAddGiftOptionToCart(btn) {
    btn.setAttribute('disabled', true);
    const index = parseInt(btn.getAttribute('data-index'));
    const id = btn.getAttribute('data-product');
    const quantity = this.inputs_qty[index].value

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id, quantity })
    });

    const data = await response.json();
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      bubbles: true
    }));
    btn.removeAttribute('disabled');
    this.validateJourney();
  }

  debounce(callback, delay = 500) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }

  async inputChange(input) {
    const key = input.getAttribute('name');
    const value = input.value;
    this.gift_card_msg[key] = value
    this.validateJourney();

    if (value === '') return input.classList.remove('input__saving');
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          [key]: value
        }
      })
    });
    input.classList.remove('input__saving');
  }

  async validateJourney() {
    const productsId = [];
    this.add_btns.forEach((btn) => productsId.push(parseInt(btn.getAttribute('data-product'))));

    const { de, para, mensaje, es_regalo } = this.gift_card_msg;

    if (!es_regalo) {
      this.journey_error.classList.add('hidden');
      this.checkoutBtn.removeAttribute('disabled');
      return
    }

    if (de.length > 0 && para.length > 0 && mensaje.length > 0 && es_regalo) {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const { items } = cart;
      const isProductInCart = items.some(item => productsId.includes(item.id));
      if (isProductInCart) {
        this.checkoutBtn.removeAttribute('disabled');
        this.journey_error.classList.add('hidden');
        return
      }
      else {
        this.journey_error.classList.remove('hidden');
      }
    }

    this.checkoutBtn.setAttribute('disabled', true);
  }
}

customElements.define('cart-gift-selector', GiftSelector);